import { Component, forwardRef, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { OrderApiService } from '@services/orders/order-api.service';
import { IOrderAccount } from '@models/orders/order-master';

@Component({
  selector: 'lib-order-account-selector',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule],
  template: `
    <ng-select
      [items]="orderAccounts"
      bindLabel="account_name"
      bindValue="account_id"
      [placeholder]="placeholder"
      [clearable]="clearable"
      [(ngModel)]="value"
      (change)="onSelectChange($event)">
    </ng-select>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OrderAccountSelectorComponent),
      multi: true
    }
  ]
})
export class OrderAccountSelectorComponent implements OnInit, ControlValueAccessor {
  orderService: OrderApiService = inject(OrderApiService);

  @Input() placeholder = 'Select Account';
  @Input() clearable = true;

  get orderAccounts(): IOrderAccount[] {
    return this.orderService.orderAccounts || [];
  }

  value: any = null;

  onChange: any = () => { /* empty */ };
  onTouched: any = () => { /* empty */ };

  ngOnInit(): void {
    if (!this.orderService.orderAccounts || this.orderService.orderAccounts.length === 0) {
      this.orderService.getAllOrderAccounts();
    }
  }

  writeValue(value: any): void {
    if (value === undefined || value === null) {
      const lastUsed = localStorage.getItem('mavles_last_order_account_id');
      if (lastUsed) {
        this.value = Number(lastUsed);
        // Schedule onChange so the parent form picks up the default value
        setTimeout(() => this.onChange(this.value));
      } else {
        this.value = null;
      }
    } else {
      this.value = Number(value);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onSelectChange(event: any): void {
    this.value = event ? event.account_id : null;
    if (this.value) {
      localStorage.setItem('mavles_last_order_account_id', String(this.value));
    }
    this.onChange(this.value);
    this.onTouched();
  }
}
